module.exports = __webpack_public_path__ + "f7811fe487ecc9a1c4a2251cf740fbe3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-23.png
// module id = 2227
// module chunks = 0